module.exports = __webpack_public_path__ + "static/media/vintagesilver2.36a5ba17.PNG";